import { render, staticRenderFns } from "./activityCheckRecord.vue?vue&type=template&id=3b0b45b1&scoped=true&"
import script from "./activityCheckRecord.vue?vue&type=script&lang=js&"
export * from "./activityCheckRecord.vue?vue&type=script&lang=js&"
import style0 from "./activityCheckRecord.vue?vue&type=style&index=0&id=3b0b45b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0b45b1",
  null
  
)

component.options.__file = "activityCheckRecord.vue"
export default component.exports